import React, { useEffect } from 'react';
import { inject, observer } from 'mobx-react';
import Layout from '@containers/Layout';
import TracksHistory from '@components/TracksHistory';
import { useLocation } from 'react-router-dom';
import ReactPaginate from 'react-paginate';

import Loader from '@components/Loader';
import { FlexListBox, List, Pagination } from '@styles/globalStyles';

import { Wrapper as SearchTopBar } from '@components/SearchBar/style';

import styled from '@emotion/styled';

const StyledTopBar = styled(SearchTopBar)`
  min-height: 60px;
`;

const TracksHistoryPage = ({
  tracksHistoryStore: {
    getTracksHistory,
    isLoading,
    switchPage,
    totalPages,
    page,
  },
}) => {
  const { search: locationSearch } = useLocation();
  useEffect(() => {
    getTracksHistory();
  }, [locationSearch]);

  const view = 'list';

  return (
    <Layout>
      <FlexListBox fullwidth view={view} loading={isLoading ? 1 : 0}>
        {isLoading ? <Loader cover /> : null}
        <StyledTopBar />
        <List view={view}>
          <TracksHistory />
        </List>
        <Pagination>
          <ReactPaginate
            pageCount={totalPages}
            pageRangeDisplayed={10}
            onPageChange={({ selected }) => switchPage(selected)}
            forcePage={page - 1}
          />
        </Pagination>
      </FlexListBox>
    </Layout>
  );
};

export default inject('tracksHistoryStore')(observer(TracksHistoryPage));
